
// Mobile navigation accordions
const mobileParentButtons = document.querySelectorAll('.mob-parent-button');

mobileParentButtons.forEach((button) => {
  const subMenu = button.nextElementSibling;
  if (!subMenu || !subMenu.classList.contains('mob-secondary-level-ul')) return;

  button.addEventListener('click', (event) => {
    event.preventDefault();
    const isOpen = subMenu.classList.toggle('is-open');
    button.classList.toggle('is-expanded', isOpen);
    button.setAttribute('aria-expanded', String(isOpen));
  });
});

document.querySelectorAll('.nav-secondary-fo-back-button').forEach((backButton) => {
  backButton.addEventListener('click', () => {
    const subMenu = backButton.closest('.mob-secondary-level-ul');
    if (!subMenu) return;
    subMenu.classList.remove('is-open');
    const parentButton = subMenu.previousElementSibling;
    if (parentButton && parentButton.classList.contains('mob-parent-button')) {
      parentButton.classList.remove('is-expanded');
      parentButton.setAttribute('aria-expanded', 'false');
      parentButton.focus();
    }
  });
});


const navDesktopButtons = document.querySelectorAll('.nav-desktop-dd-btn');
const headerMegaFwLists = document.querySelectorAll('.header-nav-desktop-dd-panel');
const gcHeader = document.querySelector('.header-bar-inner');
  
function applyBackgroundColor() {
  gcHeader.classList.add('hovered');
}

function removeBackgroundColor() {
  gcHeader.classList.remove('hovered');
}

navDesktopButtons.forEach((navDesktopButton) => {
  navDesktopButton.addEventListener('mouseover', applyBackgroundColor);
  navDesktopButton.addEventListener('mouseout', removeBackgroundColor);
});

headerMegaFwLists.forEach((headerMegaFwList) => {
  headerMegaFwList.addEventListener('mouseover', applyBackgroundColor);
  headerMegaFwList.addEventListener('mouseout', removeBackgroundColor);
});


// Scrolling transition for transparent header option

const headerDiv = document.getElementById('SiteHeader');
let isScrolled = false;

window.addEventListener('scroll', function() {
  if (!headerDiv) return;
  const scrollPosition = window.pageYOffset;

  if (scrollPosition > 250 && !isScrolled) {
    headerDiv.classList.remove('hdr-trans-hp');
    isScrolled = true;
  } else if (scrollPosition <= 250 && isScrolled) {
    headerDiv.classList.add('hdr-trans-hp');
    isScrolled = false;
  }
});

// Menu drawer
  
var navdrawermobile = document.getElementById('mobNavDrawer');
var drawbg = document.getElementById('drawBg');
var navbtn = document.getElementById('hdrMenuBtn');
var navclose = document.getElementById('mobNavDrawerClose');

if (navdrawermobile && navbtn) {
  navbtn.setAttribute('aria-controls', 'mobNavDrawer');
  navbtn.setAttribute('aria-expanded', 'false');
  navdrawermobile.setAttribute('role', 'dialog');
  navdrawermobile.setAttribute('aria-hidden', 'true');
  navdrawermobile.inert = true;
  navdrawermobile.setAttribute('aria-label', navbtn.getAttribute('aria-label') || 'Menu');

  const drawerHeader = navdrawermobile.querySelector('.header-nav-drawer-header');
  if (drawerHeader && !drawerHeader.querySelector('.header-nav-drawer-title')) {
    const drawerTitle = document.createElement('span');
    drawerTitle.className = 'dialog-title header-nav-drawer-title';
    drawerTitle.textContent = navbtn.getAttribute('aria-label') || 'Menu';
    drawerHeader.insertBefore(drawerTitle, drawerHeader.firstChild);
  }
}

//if (navbtn) {
//  navbtn.addEventListener('click', function() {
//    navdrawermobile.classList.toggle('open');
//    navclose.focus();
//    drawbg.classList.toggle('open');
//    event.preventDefault();
//  });
//}


function setMenuDrawerState(isOpen) {
  if (!navdrawermobile || !drawbg || !navbtn) return;
  navdrawermobile.classList.toggle('open', isOpen);
  drawbg.classList.toggle('open', isOpen);
  navdrawermobile.setAttribute('aria-hidden', String(!isOpen));
  navdrawermobile.inert = !isOpen;
  navbtn.setAttribute('aria-expanded', String(isOpen));
  document.body.classList.toggle('body-lock-scroll', isOpen);
}

function openMenuDrawer(event) {
  if (event) event.preventDefault();
  setMenuDrawerState(true);
  window.setTimeout(() => {
    if (navclose) navclose.focus();
    if (typeof trapFocus === 'function') trapFocus(navdrawermobile, navclose || navdrawermobile);
  }, 220);
}

function closeMenuDrawer(returnFocus = true) {
  setMenuDrawerState(false);
  if (typeof removeTrapFocus === 'function') {
    removeTrapFocus(returnFocus ? navbtn : null);
  } else if (returnFocus && navbtn) {
    navbtn.focus();
  }
}

// Check if navbtn exists and is an element
if (navbtn) {
  navbtn.addEventListener('click', openMenuDrawer);
}

if(navclose) { 
  navclose.addEventListener('click', () => closeMenuDrawer());
}

if(drawbg) { 
  drawbg.addEventListener('click', () => closeMenuDrawer());
}

document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape' && navdrawermobile && navdrawermobile.classList.contains('open')) {
    closeMenuDrawer();
  }
});
